import styled from '@emotion/styled'
import { fontSizes } from '@core/Settings'

export const TotalStakeValueStyled = styled('span')({
  fontWeight: 'bold',
  fontSize: fontSizes.betslip.summary.fontSizeLarge,
})
